module.exports = __webpack_public_path__ + "1eb411829f4af558c53f45bbdd0682e4.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/salesApp/WhatsappSvgLogo.svg
// module id = 6Xy5
// module chunks = 446